import React, { Component } from "react";

class Footer extends Component {
  state = {};
  render() {
    return (
      <footer className="row text-white bg-dark fixed-bottom">
        <p className="text-center m-2">©Nasim React Skill Showcase</p>
      </footer>
    );
  }
}

export default Footer;
